import MarketHeroStats from './MarketHeroStats'
import TokenInfo from './TokenInfo'
import TradesFeedSocketProvider from '@components/trade/TradesFeedSocketProvider'
import TokenGrid from './TokenGrid'

const TokenPage = () => {
  return (
    <TradesFeedSocketProvider>
      <div className="col-span-12">
        <TokenInfo />
        <div className="pt-0 md:pt-6">
          <MarketHeroStats />
        </div>
      </div>
      <div className="space-y-4">
        <TokenGrid />
      </div>
    </TradesFeedSocketProvider>
  )
}

export default TokenPage
